<kl-grid
  [columns]="[
    {
      header: 'installed',
      binding: 'installed',
      width: 120,
      translate: true,
      visible: true
    },
    {
      header: 'locked',
      binding: 'locked',
      width: 120,
      translate: true,
      visible: true
    },
    {
      header: 'license_key',
      binding: 'license_key',
      width: 280,
      visible: true
    },
    {
      header: 'main_license_key',
      binding: 'main_license_key',
      width: 280,
      visible: true
    },
    {
      header: 'lem_end_date',
      binding: 'lem_end_date',
      format: 'date-time',
      width: 280,
      visible: true
    },
    {
      header: 'material_description',
      binding: 'material_description',
      width: 230,
      translate: true,
      visible: true
    },
    {
      header: 'current_account_description',
      binding: 'current_account_description',
      width: 230,
      translate: true,
      visible: true
    },
    {
      header: 'customer_description',
      binding: 'customer_description',
      width: 230,
      visible: true
    }
  ]"
  [deferResizing]="true"
  [tabId]="tabId || modalId"
  [service]="{
    service: 'product-license',
    name: 'product_licenses' | translate,
    filterChild: 'flat',
    form: 'PRODUCT_LICENSE',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'PRODUCT_LICENSE_MANAGEMENT'"
  [moduleName]="'PRODUCT_LICENSE_LIST'"
  [gridName]="'grdPRODUCTLICENSEList'"
  [showToolbar]="false"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [alertType]="alertType"
  [dblSelect]="dblSelect"
  [filterSelectItems]="filterSelectItems"
  [filterObject]="filterObject"
  [customFilter]="true"
  [customFilterOutlet]="'PRODUCT_LICENSE_DETAIL_FILTER'"
>
  <div class="grid-toolbar" id="gridToolbar">
    <div class="grid-toolbar-container">
      <div class="grid-toolbar-body">
        <ul class="toolbar-list" #toolbarList>
          <li class="toolbar-list-item" (click)="refresh()">
            <div class="list-button">
              <span class="list-icon">
                <i class="fal fa-refresh"></i>
              </span>
              <span class="list-item-title">{{ "refresh" | translate }}</span>
            </div>
          </li>
          <li class="toolbar-list-item">
            <div class="list-button">
              <span class="list-icon">
                <i class="fal fa-pencil"></i>
              </span>
              <span class="list-item-title" (click)="edit()">{{
                "edit" | translate
              }}</span>
            </div>
          </li>
          <li class="toolbar-list-item">
            <div class="list-button">
              <span class="list-icon">
                <i class="fal fa-filter" aria-hidden="true"></i>
              </span>
              <span class="list-item-title" (click)="filter()">{{
                "filter" | translate
              }}</span>
              <div dropdown container="body" class="list-dropdown">
                <button
                  dropdownToggle
                  type="button"
                  class="btn btn-sm list-dropdown-button"
                >
                  <i class="fal fa-angle-down" aria-hidden="true"></i>
                </button>
                <ul
                  class="dropdown-menu toolbar-dropdown-menu"
                  role="menu"
                  *dropdownMenu
                >
                  <li role="menuitem" (click)="detailFilter()">
                    <span class="list-head"></span>
                    <a class="dropdown-item">
                      <i class="fal fa-filter"></i>&nbsp;{{
                        "detail_filter" | translate
                      }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li class="toolbar-list-item">
            <div class="list-button">
              <span class="list-icon">
                <i class="fal fa-upload" aria-hidden="true"></i>
              </span>
              <span class="list-item-title">{{ "export" | translate }}</span>
              <div dropdown container="body" class="list-dropdown">
                <button
                  dropdownToggle
                  type="button"
                  class="btn btn-sm list-dropdown-button"
                >
                  <i class="fal fa-angle-down" aria-hidden="true"></i>
                </button>
                <ul
                  class="dropdown-menu toolbar-dropdown-menu"
                  role="menu"
                  *dropdownMenu
                >
                  <li role="menuitem" (click)="exportAs('PDF')">
                    <span class="list-head"></span>
                    <a class="dropdown-item">
                      <i class="fal fa-file-pdf-o" aria-hidden="true"></i>
                      {{ "pdf" | translate }}</a
                    >
                  </li>
                  <li role="menuitem" (click)="exportAs('XLSX')">
                    <span class="list-head"></span>
                    <a class="dropdown-item">
                      <i class="fal fa-file-excel-o" aria-hidden="true"></i>
                      {{ "excel" | translate }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!--  <div class="filter-container" *ngIf="showFilterContainer">-->
  <!--    <form #filterForm="ngForm" class="col-md-12 col-sm-12">-->
  <!--      <div class="form-row">-->
  <!--        <div class="col-md-3 col-sm-12">-->
  <!--          <div class="form-group">-->
  <!--            <label class="sr-only" for="filter_text">{{'search_value' | translate}}</label>-->
  <!--            <input type="text"-->
  <!--                   name="filter_text"-->
  <!--                   placeholder="{{'search_value' | translate}}"-->
  <!--                   id="filter_text" [(ngModel)]="textToFilter"-->
  <!--                   class="form-control form-control-sm">-->
  <!--          </div>-->
  <!--        </div>-->
  <!--        <div class="col-md-3 col-sm-12">-->
  <!--          <div class="form-group">-->
  <!--            <select name="filter_type" class="form-control form-control-sm"-->
  <!--                    [(ngModel)]="filterType">-->
  <!--              <option *ngFor="let filterableItem of filterSelectItems;" [ngValue]="filterableItem">-->
  <!--                {{filterableItem.description | translate}}-->
  <!--              </option>-->
  <!--            </select>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--        <div class="col-md-2 col-sm-12">-->
  <!--          <div class="form-group">-->
  <!--            <select name="filter_property" class="form-control form-control-sm"-->
  <!--                    [(ngModel)]="filterExpression" id="filter_property">-->
  <!--              <option value="LIKE" selected>{{ 'LIKE' | translate }}</option>-->
  <!--              <option value="NOT_LIKE">{{ 'NOT_LIKE' | translate }}</option>-->
  <!--              <option value="EQ">{{ 'EQ' | translate }}</option>-->
  <!--              <option value="NOT_EQ">{{ 'NOT_EQ' | translate }}</option>-->
  <!--              <option value="START_WITH">{{ 'START_WITH' | translate }}</option>-->
  <!--              <option value="END_WITH">{{ 'END_WITH' | translate }}</option>-->
  <!--              <option value="GT">{{ 'GT' | translate }}</option>-->
  <!--              <option value="GE">{{ 'GE' | translate }}</option>-->
  <!--              <option value="LT">{{ 'LT' | translate }}</option>-->
  <!--              <option value="LE">{{ 'LE' | translate }}</option>-->
  <!--            </select>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--        <div class="col-md-2 col-sm-12">-->
  <!--          <div class="form-group">-->
  <!--            <label class="sr-only" for="filter_count">Sayı</label>-->
  <!--            <input type="number" name="filter_count" id="filter_count"-->
  <!--                   class="form-control form-control-sm"-->
  <!--                   [(ngModel)]="pageSize" [value]="pageSize" [max]="maxCount"-->
  <!--                   [min]="minCount">-->
  <!--          </div>-->
  <!--        </div>-->
  <!--        <div class="col-md-2 col-sm-12">-->
  <!--          <div class="form-group">-->
  <!--            <div class="btn-group" role="group" dropdown>-->
  <!--              <button type="button" (click)="submit()" class="btn btn-info btn-sm" [disabled]="isFilterButtonDisabled"-->
  <!--                      #listData>-->
  <!--                <i class="fal fa-list" aria-hidden="true"></i>-->
  <!--                Listele-->
  <!--              </button>-->
  <!--              <button id="button-split" type="button" dropdownToggle class="btn btn-info"-->
  <!--                      aria-controls="dropdown-split">-->
  <!--                <i class="fal fa-angle-down" aria-hidden="true"></i>-->
  <!--              </button>-->
  <!--              <ul id="dropdown-split" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-split">-->
  <!--                <li role="menuitem" (click)="saveFastFilterLayout()">-->
  <!--                  <span class="list-head"></span>-->
  <!--                  <a class="dropdown-item">{{'save' | translate}}</a>-->
  <!--                </li>-->
  <!--              </ul>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </form>-->
  <!--  </div>-->
</kl-grid>
